export const LOADING_WAIT_IN_MS = 1000;

export const RESIDENT_TYPE_OPTIONS = [
  {
    label: 'Citizen',
    value: 'Citizen',
  },
  {
    label: 'Resident',
    value: 'Resident',
  },
  {
    label: 'Tin',
    value: 'Tin',
  },
  {
    label: 'WorkVisa',
    value: 'WorkVisa',
  },
];
